/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_DinnerInputs */

const en_homepage_listen_in_dinner = /** @type {(inputs: Homepage_Listen_In_DinnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Making Dinner`)
};

const es_homepage_listen_in_dinner = /** @type {(inputs: Homepage_Listen_In_DinnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando la cena`)
};

/**
* | output |
* | --- |
* | "Making Dinner" |
*
* @param {Homepage_Listen_In_DinnerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_dinner = /** @type {((inputs?: Homepage_Listen_In_DinnerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_DinnerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_dinner(inputs)
	return en_homepage_listen_in_dinner(inputs)
});